import { defineMessages } from 'react-intl'

const messages = defineMessages({
  email: {
    id: 'global.email',
  },
  introduceEmail: {
    id: 'global.email-booking',
  },
  forYourSafety: {
    id: 'global.safety-verification',
  },
  verifyEmailUnathorized: {
    id: 'login.valid-email',
  },
  cancelYourBooking: {
    id: 'reservation.cancel-your-booking',
  },
})

export default messages
